import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { PatientRegisterService } from 'src/app/screens/patient-registration/services/patient-register.service';

@Component({
  selector: 'app-video-recording',
  templateUrl: './video-recording.component.html',
  styleUrls: ['./video-recording.component.scss']
})
export class VideoRecordingComponent implements OnInit {
  patientId
  patientRegistration
  videoList :any
  constructor(
    private activeRoute: ActivatedRoute,
    private patientRegisterService: PatientRegisterService,
  ) { }

  ngOnInit(): void {
    this.patientId = this.activeRoute.snapshot.params.id;    
    this.getPatientDetails()

  }

  getPatientDetails() {
    let payload = { patient_id: this.patientId }
    this.patientRegisterService.getPatientRegistration(payload).subscribe((res: any) => {      
      this.patientRegistration = res;
      console.log("Video data is", this.patientRegistration);
      this.getRecordingDetails()
    })
   
  }

  getRecordingDetails(){
    let payload = {
      patient_id: this.patientRegistration.patient_id,
    }
    this.patientRegisterService.getListVideoRecording(payload).subscribe((res:any)=>{
      this.videoList = res;
      console.log("video list",this.videoList);
      
    })
  }
}
